import { Link } from "react-router-dom";
import { FaCertificate, FaUserMd, FaHospital, FaGraduationCap, FaChevronRight } from 'react-icons/fa';
import contentConfig from "../content.config.json";
import "../Styles/Home.css";

const Home = () => {
  const { hero, about, doctor, certifications } = contentConfig.home;

  const iconMap = {
    certificate: FaCertificate,
    userMd: FaUserMd,
    hospital: FaHospital,
    graduationCap: FaGraduationCap,
  };

  return (
    <div className="home-container">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-background">
          <div className="hero-gradient"></div>
        </div>
        <div className="hero-content">
          <img src="/images/hero_logo.svg" alt="Practice Logo" className="hero-logo" />
          <h1 className="hero-title">{hero.title}</h1>
          <p className="hero-subtitle">{hero.subtitle}</p>
          <Link to={hero.ctaLink} className="hero-cta">
            {hero.ctaText} <FaChevronRight />
          </Link>
        </div>
      </div>

      {/* About Section */}
      <section className="about-section">
        <div className="about-container">
          <div className="about-content">
            <div className="section-header">
              <h2 className="section-title">{about.title}</h2>
            </div>
            <p className="about-text">{about.description}</p>
            <Link to={about.ctaLink} className="btn-primary">
              {about.ctaText} <FaChevronRight />
            </Link>
          </div>
          <div className="about-media">
            <div className="video-wrapper">
              <iframe
                src={about.videoUrl}
                title="About Us Video"
                frameBorder="0"
                allow="autoplay; fullscreen"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Doctor Section */}
      <section className="doctor-section">
        <div className="doctor-container">
          <div className="doctor-header">
            <div className="doctor-image-wrapper">
              <img src={doctor.imagePath} alt={doctor.name} className="doctor-image" />
            </div>
            <div className="doctor-intro">
              <h2 className="doctor-name">{doctor.name}</h2>
              <p className="doctor-bio">{doctor.bio}</p>
            </div>
          </div>

          <div className="doctor-quote-card">
            <div className="quote-icon">"</div>
            <p className="doctor-quote">{doctor.quote}</p>
            <p className="doctor-signature">— {doctor.signature}</p>
          </div>

          <div className="credentials-grid">
            {doctor.credentials.map((credential, index) => {
              const Icon = iconMap[credential.icon];
              return (
                <div key={index} className="credential-card">
                  <div className="credential-icon">
                    <Icon />
                  </div>
                  <h3 className="credential-title">{credential.title}</h3>
                  <p className="credential-description">{credential.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Certifications Section */}
      <section className="certifications-section">
        <div className="certifications-container">
          {certifications.map((cert, index) => (
            <div key={index} className="certification-item">
              <img src={cert.imagePath} alt={cert.name} />
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Home;